import * as React from 'react'
import { FC, useContext } from 'react'
import Masonry from 'react-masonry-css'
import { TitleContext } from '../TitleDetails'
import Section from '../fragments/Section'
import TitleText from '../fragments/TitleText'
import TitleSongs from '../fragments/TitleSongs'

import './Categories.scss'
import ComingSoon from '../fragments/ComingSoon'

const Categories: FC = () => {
    const context = useContext(TitleContext)
    return (
        <Section id="categories" className="Categories">
            {context.titleData.categoriesComingSoon ? 
                <ComingSoon /> :
                <Masonry className="Categories__masonry" breakpointCols={4} columnClassName="Categories__masonry__col">
                    {context.titleData.categories.map((category, index) => {
                        if (category.type === 'standard') {
                            return (
                                <TitleText key={index} title={category.label}>
                                    {category.text && <div dangerouslySetInnerHTML={{ __html: category.text }}></div>}
                                </TitleText>
                            )
                        }
                        if (category.type === 'music') {
                            return <TitleSongs key={index} title={category.label} songs={category.song ?? []} />
                        }
                    })}
                </Masonry>
            }
        </Section>
    )
}

export default Categories
